// name of fields in CreationWizard root component state
export default {};
